import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const sgdAdminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService)
  const router = inject(Router)

  if (authService.isAuthenticated()) {
    const tokenData = authService.getTokenData()
    if (tokenData && tokenData.roles.includes("sgd_admin")) {
      return true
    }
  }
  return router.navigate(["/login"])
};
